import EmberRouter from '@ember/routing/router';
import config from 'bullitttime-event/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function()
{
  this.route('timing', function()
  {
      this.route('impulses');
	  this.route('penaltyRecords');
	  this.route('startRecords');
	  this.route('moveStartRecord');
	  this.route('moveFinishRecord');
	  this.route('moveIntermediateRecord');
  });
  this.route('events');
  this.route('importEvent');
  this.route('event', { path: '/events/:event_id' }, function()
  {
	this.route('dashboard');
    this.route('details');
	this.route('jury');
	this.route('timingRecords');
	this.route('classes');
	this.route('courses');
	this.route('course',function()
	{
		this.route('editor',{ path: '/:course_id/editor' });
	});
	this.route('classgroup',function()
	{
		this.route('editor',{ path: '/:classgroup_id/editor' });
	});

	this.route('impulses');
	this.route('timing',function()
	{
	    this.route('start');
		this.route('massStart');
	    this.route('finish');
		this.route('ties');
		this.route('penalty');
		this.route('intermediate');
		this.route('backup');
		this.route('control');
	});
	this.route('upload',function()
	{
		this.route('startListUpload');
		this.route('teams');
	});
	this.route('tools',function()
	{
		this.route('quarterfinals');
		this.route('semifinals');
		this.route('semifinalsQual');
		this.route('semifinalsU16');
		this.route('finals');
		this.route('finalsU16');
		this.route('quarterfinals50');
		this.route('semifinals50');
		this.route('finals50');
		this.route('heat');
		this.route('heatStartlist');
		this.route('gundersen');
		this.route('oTimingpoints');
		this.route('oClasses');
		this.route('nensaClasses');
		this.route('moveIntermediateTime');
		this.route('manualTime');
		this.route('controlTime');
		this.route('startValidate');
		this.route('circuitRace');
	});
	this.route('entries',function()
	{
		this.route('all');
		this.route('individual');
		this.route('teams');
	});
	this.route('results',function()
	{
		this.route('individuals');
		this.route('teams');
	});
  });
});
